import React from "react"

export const useProcessImage = (service: (file: File) => Promise<string> ) => {
  const [loading, setLoading] = React.useState(false)
  const [newFile, setNewFile] = React.useState(null)

  const getImageEdited = async () => {
    if (newFile) {
      setLoading(true)

      const res = await service(newFile);

      if (res) {
        setLoading(false)
        return res
      }
    }
  }

  return {
    getImageEdited,
    loading,
    setNewFile,
    newFile,
  }
}